import { DateTime } from 'luxon'

import { Divider, Typography } from '@mui/material'
import { isTodayDate } from '@shared/utils'

import { DateDividerDate, DateDividerWrapper } from './index.styles'

const DateDivider = ({ date }: { date: string }) => {
  const isTodayMessage = isTodayDate(date)
  const dateTimeDate = DateTime.fromISO(date)

  return (
    <DateDividerWrapper>
      <Divider />
      <DateDividerDate>
        <Typography variant="caption">{isTodayMessage ? 'Today' : dateTimeDate.toFormat('MMM dd, yyyy')}</Typography>
      </DateDividerDate>
    </DateDividerWrapper>
  )
}

export default DateDivider
